// useFilters.js - Custom hook to handle filters and query params
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export function useQueryParams() {
  const location = useLocation();
  const navigate = useNavigate();
  const [filters, setFilters] = useState(new URLSearchParams(location.search));
  const LOOKUPS = {
    __IN: "__in",
  };
  const customFiltersList = {
    doc_type: {
      lookup_key: LOOKUPS.__IN,
      can_modify: true,
    },
    doc_type_not__in:{
      lookup_key: "",
      can_modify: false,
    },
    incident_location__not_in: {
      lookup_key: "",
      can_modify: false,
    },
    role_id_not__in: {
      lookup_key: "",
      can_modify: false,
    },
  };
  

  useEffect(() => {
    // When filters change, update the URL
    navigate(`${location.pathname}?${filters.toString()}`);
  }, [filters, location.pathname, navigate]);


  const updateFilter = (key, value, bulkNewFilters=null) => {
    const newFilters = bulkNewFilters ? bulkNewFilters : new URLSearchParams(filters);
    let typeCheck = Object.prototype.toString;

    if(key !== 'offset') {
      newFilters.set('offset', 0);
    }
    if (!value) {
      newFilters.delete(key); // Remove empty filters
    }
    if (value) {
      //if array perform join to create a comma separated list for `value`
      if (typeCheck.call(value) === "[object Array]" && value.length !== 0) {
        //delete key/pair if param without '__in' already exists remove
        if (newFilters.get(key)) {
          newFilters.delete(key);
        }
        //delete key/pair if param with '__in' already exists and incoming value is only 1 remove it
        if (value.length === 1) {
          if (newFilters.get(key + LOOKUPS.__IN)) {
            newFilters.delete(key + LOOKUPS.__IN);
          }
        }
        let newKey;

        if(!customFiltersList[key]){
          // if not a custom filter then proceed with standard rule and append -- if array & array length greater than 1, append `__in` lookup to param key
          if(value.length > 1){
            newKey = key + LOOKUPS.__IN;
          }else{
            newKey = key;
          }
        }
        if(customFiltersList[key]){
          // if  a custom filter then proceed with override
          if(customFiltersList[key].can_modify){
            newKey = key + customFiltersList[key].lookup_key;
          }else{
            newKey = key;
          }
        }

        newFilters.set(newKey, value.join(","));
      } else if (
        typeCheck.call(value) === "[object Array]" &&
        value.length === 0
      ) {
        if (newFilters.get(key)) {
          // array is empty, delete key/pair
          newFilters.delete(key);
        }
        // array is empty, delete key/pair with `__in`
        newFilters.delete(key + LOOKUPS.__IN);
      } else {
        newFilters.set(key, value);
      }
    }
    setFilters(newFilters);

  };

  /*Function to update multiple filters at a time */
  const bulkUpdateFilters = (filterMap) => {
    const newFilters = new URLSearchParams(filters);

    for(let index in filterMap) {
      let filterKey = filterMap[index][0];
      let filterValue = filterMap[index][1];
     
        updateFilter(filterKey, filterValue, newFilters)
    }

  };

 

  return {
    filters,
    updateFilter,
    bulkUpdateFilters,
  };
}
